import ReviewFilterAction from '../enums/ReviewFilterAction';
import ReviewFilterShowFilter from '../enums/ReviewFilterShowFilter';
import { getAmplitudeInstance } from '../amplitudeHelpers';

type logReviewSearchResultsReturnedParams = {
  action?: ReviewFilterAction;
  activity_type_filters?: string[];
  query_term?: string;
  rating_filters?: number[];
  show_filters?: ReviewFilterShowFilter;
  time_of_year_filters?: number[];
  trail_id: number;
};

/**
 * Trigger when results are returned to the user after text search completes and/or filters are applied
 * @param params - Attributes to log with the amplitude event
 * @param params.action - The action taked to filter reviews.
 * @param params.activity_type_filters - A JSON encoded array of the activity type filter server uids applied by the user.
 * @param params.query_term - the query term if user used text search in custom search or suggested search actions
 * @param params.rating_filters - A JSON encoded array of the rating filter(s) applied by the user
 * @param params.show_filters - The types of reviews that a user filtered for (all reviews, activities, reviews with photos)
 * @param params.time_of_year_filters - A JSON encoded array of the time of year (month as denoted by integer e.g 1, 2 ,3 ) filter(s) applied by the user
 * @param params.trail_id
 */
const logReviewSearchResultsReturned = (
  { action, activity_type_filters, query_term, rating_filters, show_filters, time_of_year_filters, trail_id }: logReviewSearchResultsReturnedParams,
  callback?: () => void
) => {
  getAmplitudeInstance().logEvent(
    'review search results returned',
    {
      action,
      'activity type filters': activity_type_filters,
      'query term': query_term,
      'rating filters': rating_filters,
      'show filters': show_filters,
      'time of year filters': time_of_year_filters,
      'trail id': trail_id
    },
    callback
  );
};

export default logReviewSearchResultsReturned;
